import { graphql } from "gatsby";
import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../layouts/default";
import BGImageHeroLeft from "../sections/BGImageHeroLeft";
import CalloutList from "../sections/CalloutList";
import CalloutGrid from "../sections/CalloutGrid";
import ProductReviews from "../sections/ProductReviews";

export const query = graphql`
  {
    contentfulSubscriptionPage {
      backgroundHero {
        fluid(maxWidth: 1440, quality: 100) {
          ...GatsbyContentfulFluid_withWebp
        }
      }
      heroTitle
      heroSubtitle
      heroFooter {
        raw
      }
      perksEyebrow
      perksTitle
      perksItems {
        title
        image {
          file {
            url
          }
        }
        text {
          raw
        }
      }
      howItWorksEyebrow
      howItWorksTitle
      howItWorksItems {
        image {
          fluid(maxWidth: 1440, quality: 100) {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        title
        text {
          raw
        }
        subtitle
      }
      howItWorksCalloutTitle
      howItWorksCalloutImage {
        fluid(maxWidth: 1440, quality: 100) {
          ...GatsbyContentfulFluid_withWebp
        }
      }
    }
    contentfulProductSet(id: { eq: "c247946d-19a6-5c9b-9554-66cd91a157a3" }) {
      __typename
      name
    }
  }
`;

export default function Subscription({ data, location }) {
  const subscriptionPage = data.contentfulSubscriptionPage;

  if (process.env.GATSBY_LOCALE === "en-GB") {
    return null;
  }

  return (
    <Layout pathName={location.pathname}>
      <Helmet>
        <title>Subscription</title>
      </Helmet>
      <BGImageHeroLeft
        title={subscriptionPage.heroTitle}
        subtitle={subscriptionPage.heroSubtitle}
        footer={subscriptionPage.heroFooter.raw}
        image={subscriptionPage.backgroundHero.fluid}
      />
      <CalloutList
        headline={subscriptionPage.perksTitle}
        eyebrow={subscriptionPage.perksEyebrow}
        items={subscriptionPage.perksItems}
      />
      <CalloutGrid
        headline={subscriptionPage.howItWorksTitle}
        eyebrow={subscriptionPage.howItWorksEyebrow}
        items={subscriptionPage.howItWorksItems}
        calloutTitle={subscriptionPage.howItWorksCalloutTitle}
        calloutImage={subscriptionPage.howItWorksCalloutImage}
      />
      {/* <ProductReviews product={data.contentfulProductSet} /> */}
    </Layout>
  );
}
